/**
 * Normalizes zone coordinates to an array of polygons.
 * API may return either a single polygon (number[][]) or many polygons (number[][][]).
 */
export const normalizeZonePolygons = (coordinates: unknown): number[][][] => {
  if (!Array.isArray(coordinates) || coordinates.length === 0) {
    return [];
  }
  if (
    Array.isArray(coordinates[0]) &&
    typeof (coordinates[0] as number[][])[0] === "number"
  ) {
    return [coordinates as number[][]];
  }
  return coordinates as number[][][];
};
